<template>
	<q-page padding>
		<h1 class="q-headline">
			Will My Credits Transfer?
		</h1>
		<p class="q-body-2">
			We are helping transfer students like you earn a degree faster, saving time and money. From here, you can discover just how your prior learning will be awarded credit at our institution. Get started now and see your transfer map by adding the courses and assessments you have taken elsewhere.
		</p>

		<div class="flex flex-center">
			<q-btn v-if="canProceed" label="Get Started" color="secondary" @click="onGetStartedClick" />
			<div v-if="loading" style="text-align: center">
				<q-spinner color="secondary" :size="30" />
				<br /> Please wait&hellip;
			</div>

		</div>

		<transition enter-active-class="animated bounceInLeft" appear>
			<q-alert v-if="error" type="negative" icon="error"
				:actions="[{ label: 'Retry', handler: retryApiCheckin }]"
			>
				We're unable to communicate with the Will My Credits Transfer servers at this time.  Please try again later.
			</q-alert>
		</transition>
	</q-page>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { mapMutations, mapActions, mapState } from 'vuex';
import { State } from '@/store';
import { WillMyCreditsTransferState } from '@/store/wmct/state';

@Component({
	methods: {
		...mapMutations('wmct', {
			addCourse: 'ADD_COURSE',
		}),
		...mapActions('wmct', [
			'checkinWithApi',
		]),
	},
})
export default class HomeView extends Vue {
	private addCourse!: () => void;
	private checkinWithApi!: () => Promise<void>;

	private get state(): WillMyCreditsTransferState {
		return (this.$store.state as State).wmct;
	}

	public onGetStartedClick() {
		this.$router.replace({ name: 'my-courses' });
	}

	public get loading(): boolean {
		return this.state.api.loading;
	}

	public get canProceed() {
		return this.loading === false && this.error === false;
	}

	public get error() {
		return this.state.api.error === true;
	}

	public retryApiCheckin() {
		this.checkinWithApi();
	}
}
</script>